var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHappyBoy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "happy-boy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "happy-boy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,2C55,2,60,17.3,60,26c0,7.7-1,11-1,11H5S4,33.7,4,26C4,17.3,9,2,32,2Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2,33A64.28,64.28,0,0,1,56,22.8c-.5-7.5-10.9-1.5-24-1.5s-23.5-6-24,1.5A64.28,64.28,0,0,1,6.8,33C.3,33,.3,43.6,7.2,43.6,7.2,55,21.5,62,32,62s24.8-7,24.8-18.4c6.9,0,6.9-10.6.4-10.6",
    fill: "#8a6859"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 35.5,
    r: 6.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 35.5,
    r: 4.5,
    fill: "#9c0cfa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 35.5,
    r: 1.5,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 35.5,
    r: 6.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 35.5,
    r: 4.5,
    fill: "#9c0cfa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 35.5,
    r: 1.5,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1,48.1a13.5,13.5,0,0,1-16.2,0c-.6-.4-1.2.3-.8,1a10.53,10.53,0,0,0,17.8,0c.4-.7-.2-1.4-.8-1",
    fill: "#574137"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyBoy);
export default __webpack_public_path__ + "static/media/happy-boy.755dac71765adb85e1865cbe56139747.svg";
export { ForwardRef as ReactComponent };